export enum ErrorCode {
  M_FORBIDDEN = 'M_FORBIDDEN',
  M_LIMIT_EXCEEDED = 'M_LIMIT_EXCEEDED',

  M_USER_DEACTIVATED = 'M_USER_DEACTIVATED',
  M_USER_IN_USE = 'M_USER_IN_USE',
  M_INVALID_USERNAME = 'M_INVALID_USERNAME',
  M_WEAK_PASSWORD = 'M_WEAK_PASSWORD',
  M_PASSWORD_TOO_SHORT = 'M_PASSWORD_TOO_SHORT',

  M_EXCLUSIVE = 'M_EXCLUSIVE',
  M_MAX_DELAY_EXCEEDED = 'M_MAX_DELAY_EXCEEDED',
}
